import { ElementType, useRef, useState } from 'react';

import {
  ICalendarViewMenuItem,
  ICalendarViewMenuPresenter,
  ICalendarViewMenuReturnType,
  ICalendarViewMenuPresenterParams,
} from './CalendarViewMenu.types';

export function useCalendarViewMenuPresenter(
  params: ICalendarViewMenuPresenterParams
): ICalendarViewMenuReturnType {
  const { value, items, onChange } = params;

  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpened, setIsOpened] = useState(false);

  const presenter: ICalendarViewMenuPresenter = {
    isOpened,

    get menuItems(): ICalendarViewMenuItem[] {
      return items.map((item) => ({
        ...item,
        onClick: (): void => {
          onChange(item.key);
          presenter.onClose();
        },
      }));
    },

    get buttonLabel(): string {
      return items.find((item) => item.key === value)?.title || 'Select';
    },

    get buttonIcon(): ElementType | undefined {
      return items.find((item) => item.key === value)?.icon;
    },

    toggleIsOpened(): void {
      setIsOpened((currentIsOpened) => !currentIsOpened);
    },

    onClose(): void {
      setIsOpened(false);
    },
  };

  return { buttonRef, presenter };
}
